var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { IMaskInput } from 'react-imask';
import { getPostalMask } from '@repo/shared/constants';
var MaskedInput = forwardRef(function MaskedInput(_a, ref) {
    var onChange = _a.onChange, name = _a.name, other = __rest(_a, ["onChange", "name"]);
    return (_jsx(IMaskInput, __assign({}, other, { inputRef: ref, overwrite: true, onAccept: function (value) {
            var event = {
                target: {
                    name: name,
                    value: value,
                },
            };
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        } })));
});
export function PostalCodeInput(_a) {
    var name = _a.name, countryCode = _a.countryCode, _b = _a.isCustomError, isCustomError = _b === void 0 ? false : _b, rest = __rest(_a, ["name", "countryCode", "isCustomError"]);
    return (_jsx(Controller, { name: name, render: function (_a) {
            var _b, _c, _d, _e, _f;
            var field = _a.field, fieldState = _a.fieldState;
            return (_jsx(TextField, __assign({}, field, { fullWidth: true, error: Boolean(fieldState.error), helperText: isCustomError ? undefined : (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }, rest, { slotProps: {
                    input: __assign({ inputComponent: MaskedInput, inputProps: {
                            mask: getPostalMask(countryCode),
                            autoComplete: 'postal-code',
                        } }, ((_d = (_c = rest.slotProps) === null || _c === void 0 ? void 0 : _c.input) !== null && _d !== void 0 ? _d : {})),
                    inputLabel: __assign({ shrink: !!field.value }, ((_f = (_e = rest.slotProps) === null || _e === void 0 ? void 0 : _e.inputLabel) !== null && _f !== void 0 ? _f : {})),
                } })));
        } }));
}
